import { payment_links as paymentLinks } from '@repo/domain-types/cards-acceptance';
import type { SetNonNullableDeep } from 'type-fest';

export type PaymentMethod = paymentLinks.methods.firstparty.v1.ApiMethod;

export const PaymentMethodStatusValue = paymentLinks.methods.firstparty.v1.ApiMethodStatusValue;
export const PaymentMethodLocation = paymentLinks.methods.firstparty.v1.ApiMethodLocation;

export type V3PaymentLink = paymentLinks.firstparty.v3.ApiPaymentLink;
export type V3ListPaymentLinksResponse = paymentLinks.firstparty.v3.ApiGetPaymentLinksResponse;

export type PaymentLink = SetNonNullableDeep<paymentLinks.firstparty.v4.ApiPaymentLink, 'amount'>;
export type PaymentLinkStatus = paymentLinks.firstparty.v4.ApiPaymentLinkStatus;
export type V4PaymentMethod = paymentLinks.firstparty.v4.ApiPaymentMethod;
export type V2PaymentMethodAvailability = paymentLinks.firstparty.v2.ApiMethodAttributes;
export type V4PaymentMethodAvailability = paymentLinks.firstparty.v4.ApiMethod;
export type ResourceType = paymentLinks.firstparty.v4.ApiResourceType;
export type ItemType = paymentLinks.firstparty.v4.ApiItemType;
export type PaymentLinkRecurrenceType = paymentLinks.firstparty.v4.ApiPaymentLinkRecurrenceType;
export type ListPaymentLinksResponse = paymentLinks.firstparty.v4.ApiSearchPaymentLinksResponse;
export type PaymentLinkSubscription = paymentLinks.firstparty.v4.ApiSubscription;
